<div class="container-fluid">
  <div class="row">
    <div class="col-60 p-0">
      <div class="d-flex flex-row justify-content-center w-100 position-relative">
        <div class="bg-gray catalog-slider-background"></div>
        <div class="w-100 container-fluid-960">
          <ng-container *ngIf="items">
            <div class="position-relative">
              <div class="swiper-container" [swiper]="config">
                <div class="swiper-wrapper">
                  <div class="swiper-slide " *ngFor="let item of items">
                    <app-box-catalog [colorSubtitle]="item.color" [title]="item.title" [subTitle]="item.subTitle" [url]="item.url" [text]="item.text" [image]="item.image"></app-box-catalog>
                  </div>
                </div>
                <div class="swiper-pagination swiper-pagination-elsa swiper-pagination-catalog"></div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
